import clsx from 'clsx';
import { v4 } from 'uuid';

export default function SelectField({
    'aria-label': ariaLabel,
    className,
    'data-testid': dataTestId,
    defaultValue,
    info: InfoComponent,
    label,
    name,
    options,
    value,
    onChange,
}: SelectFieldProps) {
    function focus(e: any) {
        e.currentTarget.closest('.field-group').querySelector('select').click();
    }

    const containerClasses = clsx('d-flex flex-column-reverse field-group', className);

    const id = `${v4()}-${name}`;

    return (
        <div className={containerClasses} data-testid={dataTestId}>
            <div className="field-control">
                <select
                    aria-label={ariaLabel ?? label}
                    id={id}
                    name={name}
                    value={value}
                    onChange={e => onChange(e.target.value)}
                >
                {Object.entries(options).map(([optValue, optLabel]: any, index) => (
                    <option key={index} value={optValue}>{optLabel}</option>
                ))}
                </select>
                <div className="field-input field-value">{options[value]}</div>
                {defaultValue && defaultValue === value && (
                    <div className="field-default" onClick={focus}>(Default)</div>
                )}
            </div>
            {label && (
                <div>
                    <label className="field-label" htmlFor={id}>
                        {label}
                    </label>
                    {InfoComponent && <InfoComponent />}
                </div>
            )}
        </div>
    );
}